import { render, staticRenderFns } from "./AdminRoleModal.vue?vue&type=template&id=6dfd570b&scoped=true&"
import script from "./AdminRoleModal.vue?vue&type=script&lang=js&"
export * from "./AdminRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoleModal.vue?vue&type=style&index=0&id=6dfd570b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd570b",
  null
  
)

export default component.exports